import { cva } from 'class-variance-authority';
export const getInputContainerClasses = cva([
    'flex w-full items-center',
    'border border-solid',
    'transition-[box-shadow,border-color] duration-quick',
    'focus-within:border-focus',
    'bg-raised',
    'ring-0 interactable-within',
].join(' '), {
    variants: {
        size: { default: 'h-10 gap-2', small: 'h-8 gap-1.5' },
        error: { false: 'border-base', true: 'border-negative-strong' },
        disabled: { false: '', true: 'cursor-default bg-subtle opacity-50' },
        rounded: { true: 'rounded-full', false: 'rounded-lg' },
    },
    compoundVariants: [
        { disabled: false, error: false, class: '' },
        { size: 'default', rounded: false, class: 'px-2' },
        { size: 'default', rounded: true, class: 'px-3' },
        { size: 'small', rounded: false, class: 'px-2' },
        { size: 'small', rounded: true, class: 'px-3' },
    ],
    defaultVariants: { size: 'default', error: false, disabled: false, rounded: false },
});
export const getInputFieldClasses = cva([
    'flex-1 min-w-0',
    'bg-transparent border-none appearance-none',
    'text-primary placeholder:text-tertiary',
    // Overflowing text and placeholders fade out with an ellipsis instead of
    // being clipped mid-glyph. Localized copy routinely runs longer than the
    // English source, so a hard clip cuts words in half in other languages.
    'text-ellipsis placeholder:text-ellipsis',
    'outline-none',
].join(' '), {
    variants: { size: { default: 'text-base md:text-sm', small: 'text-base md:text-sm' } },
    defaultVariants: { size: 'default' },
});
//# sourceMappingURL=classes.js.map